// src/pages/KnowledgePage.js
// Wrapper fino — padrão src/pages/*Page.js
import KnowledgeDashboard from '../components/KnowledgeDashboard';

export default function KnowledgePage() {
  return <KnowledgeDashboard />;
}
